// require('dotenv').config();

export const IS_DEV = process.env.REACT_APP_IS_DEVELOPMENT === '1';
export const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === '1';

const serverUrl =
  'https://us-central1-nonograms-225103.cloudfunctions.net/nono-gql';
const devServerUrl =
  'https://us-central1-nonograms-225103.cloudfunctions.net/nono-gql-dev';

const localUrl = 'http://localhost:8080/nono-gql';

export const GRAPHQL_URL = IS_LOCAL
  ? localUrl
  : IS_DEV
  ? devServerUrl
  : serverUrl;

// TODO: Make these correct
const restUrl = 'https://us-central1-nonograms-225103.cloudfunctions.net/api';
const devRestUrl = 'https://nonograms-online.com/api-dev';
const localRestUrl = 'http://localhost:8080/api';
export const REST_API_URL = IS_LOCAL
  ? localRestUrl
  : IS_DEV
  ? devRestUrl
  : restUrl;

export const AD_TEST = true;

export const ANALYTICS_ID = 'G-7J6GF08E3S';
